import { firestore, FirestoreCollections } from '../configs/firebase';
import {
  doc,
  getDoc,
} from 'firebase/firestore';

export const getDomainById = async (idDomain: string) => {
  try {
    const domainDocRef = doc(firestore, FirestoreCollections.domains, idDomain);
    const domainDoc = await getDoc(domainDocRef);

    if (domainDoc.exists()) {
      return {
        success: true,
        status: 'success',
        msg: 'Domain récupéré avec succès.',
        doc: domainDoc.data(),
      };
    } else {
      return {
        success: false,
        status: 'error',
        msg: 'Domain non trouvé',
      };
    }
  } catch (error) {
    return {
      success: false,
      status: 'error',
      msg: (error as Error).message.toLocaleString(),
    };
  }
};

export default {
  getDomainById,
};